import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

function HistoryEditModal({ isOpen, onClose, historyItem, onSave }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    foodName: '',
    culture: 'ETHIOPIAN',
    safetyStatus: 'SAFE',
    message: ''
  });

  useEffect(() => {
    if (historyItem) {
      setFormData({
        foodName: historyItem.foodName || '',
        culture: historyItem.culture || 'ETHIOPIAN',
        safetyStatus: historyItem.safetyStatus || 'SAFE',
        message: historyItem.message || ''
      });
    }
  }, [historyItem]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={historyItem ? `✏️ ${t('history.edit.titleEdit')}` : `➕ ${t('history.edit.titleAdd')}`}>
      <form className="modal-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>🍎 {t('history.edit.foodName')}</label>
          <input
            type="text"
            value={formData.foodName}
            onChange={(e) => setFormData({...formData, foodName: e.target.value})}
            required
            placeholder={t('history.edit.foodNamePlaceholder')}
          />
        </div>
        
        <div className="form-group">
          <label>🌍 {t('history.edit.culture')}</label>
          <select
            value={formData.culture}
            onChange={(e) => setFormData({...formData, culture: e.target.value})}
            required
          >
            <option value="ETHIOPIAN">🇪🇹 {t('history.edit.cultureEthiopian')}</option>
            <option value="ERITREAN">🇪🇷 {t('history.edit.cultureEritrean')}</option>
            <option value="SPANISH">🇪🇸 {t('history.edit.cultureSpanish')}</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>🛡️ {t('history.edit.safetyStatus')}</label>
          <select
            value={formData.safetyStatus}
            onChange={(e) => setFormData({...formData, safetyStatus: e.target.value})}
            required
          >
            <option value="SAFE">✅ {t('history.edit.safe')}</option>
            <option value="UNSAFE">❌ {t('history.edit.unsafe')}</option>
            <option value="CAUTION">⚠️ {t('history.edit.caution')}</option>
          </select>
        </div>
        
        <div className="form-group">
          <label>💬 {t('history.edit.message')}</label>
          <textarea
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
            rows="3"
            placeholder={t('history.edit.messagePlaceholder')}
          />
        </div>
        
        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={onClose}>
            {t('history.edit.cancel')}
          </button>
          <button type="submit" className="btn-primary">
            💾 {historyItem ? t('history.edit.update') : t('history.edit.create')}
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default HistoryEditModal;
















